import { h } from 'preact';
import PlusIcon from './icons/plus.svg';
import MinusIcon from './icons/minus.svg';

const Accordion = ({
  data,
  index,
  activeAccordions,
  setActiveAccordions,
  allowMultiple = false,
  buttonWrapperClass = 'w-full cursor-pointer flex justify-between items-center gap-5 py-[30px] border border-grey-700 border-l-0 border-r-0 border-b-0 border-t-0 text-primary-2',
  buttonClass = 'heading-5',
  buttonActiveClass = 'heading-4',
  contentClass = 'font-m-14 text-primary-2 mb-5',
  contentWrapperClass = 'overflow-hidden max-h-0 transition-all duration-300 pr-[42px]',
  iconClass = 'text-white',
}) => {
  const isActive = activeAccordions.includes(index);

  const toggleAccordion = () => {
    if (allowMultiple) {
      setActiveAccordions((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index)
          : [...prev, index],
      );
    } else {
      setActiveAccordions((prev) => (prev.includes(index) ? [] : [index]));
    }
  };

  return (
    <div>
      <button
        type="button"
        aria-expanded={isActive}
        aria-controls={`accordion-content-${index}`}
        id={`accordion-header-${index}`}
        onClick={toggleAccordion}
        className={`${buttonWrapperClass} ${
          index !== 0 ? 'border-t-[1px]' : ''
        } ${isActive ? 'pb-5' : ''}`}
      >
        <p className={`${isActive ? buttonActiveClass : buttonClass} `}>
          {data.heading}
        </p>
        {isActive ? (
          <MinusIcon viewBox="0 0 22 22" className={iconClass} />
        ) : (
          <PlusIcon viewBox="0 0 22 22" className={iconClass} />
        )}
      </button>

      <div
        id={`accordion-content-${index}`}
        role="region"
        aria-labelledby={`accordion-header-${index}`}
        className={`${contentWrapperClass} ${
          isActive ? '!max-h-[1000px]' : ''
        }`}
      >
        <p
          className={contentClass}
          dangerouslySetInnerHTML={{ __html: data.content }}
        />
        {data.url && data.cta_text && (
          <a
            href={data.url}
            className="btn-primary-stroke-inverse bg-transparent mb-[18px]"
          >
            {data.cta_text}
          </a>
        )}
      </div>
    </div>
  );
};

export default Accordion;
